import { LocalizedText } from '@mews/framework';
import { Highlight, Spinner, Stack } from '@optimus-web/core';

interface LoaderProps {
    statusTextKey?: Mews.TextKey;
    small?: boolean;
    fill?: boolean;
}

export const Loader = ({ statusTextKey, small = false, fill }: LoaderProps) => (
    <Stack spacing={small ? '200' : '400'} itemAlignment="center" alignment="center" vertical fill={fill}>
        <Spinner />
        {
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            statusTextKey ? (
                <Highlight size="medium">
                    <LocalizedText textKey={statusTextKey} />
                </Highlight>
            ) : null
        }
    </Stack>
);
